import React, { useState } from 'react';
import { supabase } from '../supabase';

function LoginPage({ onLogin }) {
  const [userId, setUserId] = useState('');
  const [userRooms, setUserRooms] = useState([]);
  const [newRoomKey, setNewRoomKey] = useState('');
  const [showRoomList, setShowRoomList] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleUserIdSubmit = async (e) => {
    e.preventDefault();
    
    if (!userId.trim()) {
      alert('请输入用户ID');
      return;
    }

    if (userId.length > 20) {
      alert('用户ID不能超过20个字符');
      return;
    }

    setLoading(true);
    try {
      await fetchUserRooms(userId.trim());
    } finally {
      setLoading(false);
    }
  };

  const fetchUserRooms = async (userIdValue) => {
    try {
      // 查询用户参与的房间
      const { data: playerRooms, error } = await supabase
        .from('players')
        .select(`
          room_id,
          is_host,
          rooms (
            id,
            room_key,
            room_name,
            status,
            current_players,
            max_players
          )
        `)
        .eq('player_name', userIdValue);

      if (error) {
        console.error('查询房间失败:', error);
        setUserRooms([]);
      } else {
        setUserRooms(playerRooms || []);
      }
      
      setShowRoomList(true);
    } catch (error) {
      console.error('获取用户房间失败:', error);
      setUserRooms([]);
      setShowRoomList(true);
    }
  };

  const handleRoomSelect = async (roomKey) => {
    setLoading(true);
    try {
      await onLogin(roomKey, userId);
    } finally {
      setLoading(false);
    }
  };

  const handleCreateRoom = async (e) => {
    e.preventDefault();
    
    if (!newRoomKey.trim()) {
      alert('请输入房间密钥');
      return;
    }

    await handleRoomSelect(newRoomKey.trim());
  };

  if (!showRoomList) {
    // 第一步：输入用户ID
    return (
      <div className="container">
        <div className="card">
          <h1 className="page-title">🃏 德州扑克</h1>
          
          <form onSubmit={handleUserIdSubmit}>
            <div className="form-group">
              <label>用户ID</label>
              <input
                type="text"
                value={userId}
                onChange={(e) => setUserId(e.target.value)}
                placeholder="输入您的唯一用户ID"
                className="input"
                maxLength="20"
                required
              />
              <small style={{ color: '#9ca3af', fontSize: '12px' }}>
                用户ID是您的唯一标识，用于查找您的游戏记录
              </small>
            </div>

            <button 
              type="submit" 
              className="btn btn-primary"
              disabled={loading}
              style={{ width: '100%' }}
            >
              {loading ? '查询中...' : '查询我的房间'}
            </button>
          </form>

          <div style={{ marginTop: '30px', padding: '20px', backgroundColor: 'rgba(59, 130, 246, 0.1)', borderRadius: '8px' }}>
            <h3 style={{ marginBottom: '10px', color: '#3b82f6' }}>游戏说明</h3>
            <ul style={{ fontSize: '14px', lineHeight: '1.6', color: '#d1d5db' }}>
              <li>• 每位玩家初始筹码：1000</li>
              <li>• 最多6人同时游戏</li>
              <li>• 第一位加入的玩家自动成为房主</li>
              <li>• 房主可以开始/结束游戏</li>
              <li>• 支持实时同步游戏状态</li>
            </ul>
          </div>
        </div>
      </div>
    );
  }

  // 第二步：显示房间列表
  return (
    <div className="container">
      <div className="card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h1 className="page-title">🃏 {userId} 的房间</h1>
          <button 
            onClick={() => setShowRoomList(false)}
            className="btn btn-secondary"
            style={{ padding: '8px 16px', fontSize: '14px' }}
          >
            返回
          </button>
        </div>
        
        {/* 用户已有的房间 */}
        {userRooms.length > 0 && (
          <div style={{ marginBottom: '30px' }}>
            <h3 style={{ marginBottom: '15px', color: '#3b82f6' }}>我的房间</h3>
            <div className="room-list">
              {userRooms.map(playerRoom => (
                <div 
                  key={playerRoom.room_id}
                  className="room-item"
                  onClick={() => handleRoomSelect(playerRoom.rooms.room_key)}
                >
                  <div style={{ fontWeight: 'bold' }}>
                    {playerRoom.rooms.room_name}
                    {playerRoom.is_host && <span style={{ color: '#fbbf24', marginLeft: '8px' }}>👑</span>}
                  </div>
                  <div style={{ fontSize: '14px', color: '#9ca3af' }}>
                    房间密钥: {playerRoom.rooms.room_key}
                  </div>
                  <div style={{ fontSize: '12px', color: '#6b7280' }}>
                    状态: {playerRoom.rooms.status === 'playing' ? '游戏中' : '等待中'} | 
                    玩家: {playerRoom.rooms.current_players}/{playerRoom.rooms.max_players}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* 创建新房间 */}
        <div>
          <h3 style={{ marginBottom: '15px', color: '#10b981' }}>创建新房间</h3>
          <form onSubmit={handleCreateRoom}>
            <div className="form-group">
              <label>房间密钥</label>
              <input
                type="text"
                value={newRoomKey}
                onChange={(e) => setNewRoomKey(e.target.value)}
                placeholder="输入新房间密钥"
                className="input"
                maxLength="20"
              />
            </div>

            <button 
              type="submit" 
              className="btn btn-success"
              disabled={loading}
              style={{ width: '100%' }}
            >
              {loading ? '创建中...' : '创建房间'}
            </button>
          </form>
        </div>

        {userRooms.length === 0 && (
          <div style={{ 
            textAlign: 'center', 
            padding: '20px', 
            backgroundColor: 'rgba(156, 163, 175, 0.1)', 
            borderRadius: '8px',
            marginTop: '20px'
          }}>
            <p style={{ color: '#9ca3af' }}>您还没有参与任何房间</p>
            <p style={{ color: '#6b7280', fontSize: '14px' }}>创建一个新房间开始游戏吧！</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default LoginPage; 